import { tickIncrement } from "./ticks.js";
export default function nice(start, stop, count) {
    var prestep;
    while (true) {
        var step = tickIncrement(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) {
            return [start, stop];
        }
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        }
        else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}
